import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";
import BarLineChart from "../OfftakeCharts/BarLineChart.js";
import React, { useState, useEffect } from "react";

const day_hour_wise = async (body) => {
  try {
    const res = await axInst.post("offtake/day-wise-offtake", body);
    return res.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const DayHourWise = () => {
  const { data, submitted } = useSelector((e) => e.filtersOfftake);
  const [isHourly, setIsHourly] = useState(false);
  const [offtake, setOffTake] = useState({});
  useEffect(() => {
    if (isHourly) {
      setOffTake({ offtake_status: ["hours offtake"] });
    } else {
      setOffTake({ offtake_status: ["Daily offtake"] });
    }
  }, [isHourly]);

  const {
    data: dailyhour,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["dayhour", submitted, offtake.offtake_status],
    queryFn: () =>
      day_hour_wise({
        ...data,
        ...offtake,
      }),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  return (
    <div className="p-2 relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          {/* <p>Error Occurred</p> */}
          <p>Error Occurred: {isError.message}</p>
        </div>
      )}
      {!isFetching && !dailyhour && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Data not available</p>
        </div>
      )}
      <WaterMark />
      <div>
        {dailyhour && (
          <BarLineChart
            data={dailyhour}
            isHourly={isHourly}
            Heading={"Offtake"}
            setIsHourly={setIsHourly}
          />
        )}
      </div>
    </div>
  );
};
